
import Select from "react-dropdown-select";
import dispensaryStatesData from '../../helper/constants/dispensaries-data';
import { useEffect, useState } from "react";
import { dispensaryDropDownNormalize, dispensaryHashNormalize } from '../../helper/utility';
import { useMemo } from 'react';
import { StateDropdownContainer, StateDropdownNotAvialbleText, StateDropdownClass } from './styles';

interface StateDropdownProps {
    selectedState: string;
    onSelectState: (state: string)=> void;
}

type OptionType = {
    value: string;
    label: string;
};

const StateDropdown = ({ selectedState, onSelectState }: StateDropdownProps) => {
    const [values, setValues] = useState<OptionType[]>([]);
    const options: OptionType[] = useMemo(()=>dispensaryDropDownNormalize(dispensaryStatesData),[dispensaryStatesData]);
    const stateHashMap = useMemo(()=>dispensaryHashNormalize(dispensaryStatesData),[dispensaryStatesData]);

    useEffect(()=> {
        const state = stateHashMap[selectedState];
        if(state) {
            let value = state.name;
            setValues([{ value ,label: value }])
        }
    },[selectedState,stateHashMap])

    const onChange = (values: OptionType[])=> values[0]?.value && onSelectState(values[0]?.value);

    return (
        <StateDropdownContainer>
            <Select
                options={options}
                onChange={onChange}
                values={values}
                className={StateDropdownClass}
                noDataRenderer={()=><StateDropdownNotAvialbleText>Not Available</StateDropdownNotAvialbleText>}
            />
        </StateDropdownContainer>
    )
}

export default StateDropdown;